var _excluded = ["input", "id", "meta", "className", "type", "children"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { blurDirty, fieldPropTypes, hasInputError, omitLabelProps } from '../helpers';
import { LabeledField } from '../labels';
import { compose, filterInvalidDOMProps, generateInputErrorId } from '../../utils';

/**
 *
 * An input element that can be used in a `redux-form`-controlled form.
 *
 * Note: The `input` tag is surrounded by a `div` with class `"input-wrapper"`.
 * Any children passed to this component will be rendered within this wrapper.
 *
 * @name Input
 * @type Function
 * @param {Object} input - A `redux-form` [input](http://redux-form.com/6.5.0/docs/api/Field.md/#input-props) object
 * @param {Object} meta - A `redux-form` [meta](http://redux-form.com/6.5.0/docs/api/Field.md/#meta-props) object
 * @param {String} [type] - A string to specify the type of input element (defaults to `text`)
 * @example
 *
 * function UserForm ({ handleSubmit, pristine, invalid, submitting }) {
 *   return (
 *     <form onSubmit={ handleSubmit }>
 *       <Field
 *          name="firstName"
 *          component={ Input }
 *          placeholder="Your first name"
 *       />
 *       <SubmitButton {...{ pristine, invalid, submitting }}>
 *         Submit
 *       </SubmitButton>
 *     </form>
 *   )
 * }
 */

var propTypes = _objectSpread(_objectSpread({}, fieldPropTypes), {}, {
  type: PropTypes.string,
  children: PropTypes.node
});
var defaultProps = {
  type: 'text'
};
function Input(props) {
  var _omitLabelProps = omitLabelProps(props),
    _omitLabelProps$input = _omitLabelProps.input,
    name = _omitLabelProps$input.name,
    value = _omitLabelProps$input.value,
    onBlur = _omitLabelProps$input.onBlur,
    onChange = _omitLabelProps$input.onChange,
    id = _omitLabelProps.id,
    meta = _omitLabelProps.meta,
    className = _omitLabelProps.className,
    type = _omitLabelProps.type,
    children = _omitLabelProps.children,
    rest = _objectWithoutProperties(_omitLabelProps, _excluded);
  return /*#__PURE__*/React.createElement(LabeledField, props, /*#__PURE__*/React.createElement("div", {
    className: "input-wrapper"
  }, /*#__PURE__*/React.createElement("input", _objectSpread({
    id: id || name,
    name: name,
    type: type,
    value: value,
    onBlur: onBlur,
    onChange: onChange,
    'aria-describedby': hasInputError(meta) ? generateInputErrorId(name) : null
  }, filterInvalidDOMProps(rest))), children));
}
Input.defaultProps = defaultProps;
Input.propTypes = propTypes;
export default compose(blurDirty())(Input);